import React from "react";
import { Loader, PageListLayout } from "../../../shared";
import { useDashboard } from "../hooks";
import { StatsCards } from "../components/StatsCards";

export const DashboardUi = () => {
  const { listQuery } = useDashboard({ isList: true });
  return (
    <PageListLayout
      headerText="Dashboard"
      sx={{ bgcolor: "background.paper", height: "calc(100vh - 102px)" }}
    >
      {listQuery.isPending ? (
        <Loader />
      ) : (
        <StatsCards data={listQuery?.data?.data} />
      )}
    </PageListLayout>
  );
};
